export const fluQuestions = {
  title: "Flu vaccine questions",
  message:
    "Sorry, due to your responses, we would advise that you have your flu vaccination at your GP Surgery",
  questions: [
    {
      id: "liveVaccines",
      question:
        "Have you had any live vaccines in the last 3 weeks (yellow fever, polio etc)?",
      validation: "required",
      options: [
        { id: 1, option: "Yes" },
        { id: 2, option: "No" },
      ],
      success: "No",
    },
    {
      id: "allergicReaction",
      question:
        "Have you ever had an allergic reaction to EGGS or CHICKEN PROTEIN, or to GENTAMICIN, POLYMIXIN or NEOMYCIN (rarely used antibiotics)?",
      validation: "required",
      options: [
        { id: 3, option: "Yes" },
        { id: 4, option: "No" },
      ],
      success: "No",
    },
    {
      id: "fluImmunisationAbnormalReaction",
      question:
        "Have you had an abnormal reaction to any previous flu immunisation?",
      validation: "required",
      options: [
        { id: 5, option: "Yes" },
        { id: 6, option: "No" },
      ],
      success: "No",
    },
    {
      id: "seriousAllergicReaction",
      question: "Have you ever had ANY serious allergic reaction?",
      validation: "required",
      options: [
        { id: 7, option: "Yes" },
        { id: 8, option: "No" },
      ],
      success: "No",
    },
    {
      id: "over65",
      question: "Are you over 65?",
      validation: "required",
      options: [
        { id: 9, option: "Yes" },
        { id: 10, option: "No" },
      ],
      success: "No",
    },
    {
      id: "pregnant",
      question: "Is there any possibility that you might be pregnant?",
      validation: "required",
      options: [
        { id: 11, option: "Yes" },
        { id: 12, option: "No" },
      ],
      success: "No",
    },
  ],
};

export const covidQuestions = {
  title: "Coronavirus symptoms",
  disclaimer:
    "By booking this appointment you are consenting to having the Covid-19 test, administered by a Healthy Performance health professional.",
  message:
    "Sorry, due to your responses, we would advise that you self-isolate and contact the NHS on 119, as soon as possible.",
  questions: [
    {
      id: "highTemperature",
      question:
        "Do you have a high temperature?  This means you feel hot to touch on your chest or back (you do not need to measure your temperature).",
      validation: "required",
      options: [
        { id: 1, option: "Yes" },
        { id: 2, option: "No" },
      ],
      success: "No",
    },
    {
      id: "continousCough",
      question:
        "Do you have a new, continuous cough?  This means coughing a lot for more than an hour, or 3 or more coughing episodes in 24 hours (if you usually have a cough, it may be worse than usual).",
      validation: "required",
      options: [
        { id: 1, option: "Yes" },
        { id: 2, option: "No" },
      ],
      success: "No",
    },
    {
      id: "tasteSmell",
      question:
        "Have you lost your sense of smell or taste?  This means you've noticed you cannot smell or taste anything, or things smell or taste different to normal.",
      validation: "required",
      options: [
        { id: 1, option: "Yes" },
        { id: 2, option: "No" },
      ],
      success: "No",
    },
  ],
};
